import controller from '../product-filter.controller'
import template from './product-filter.template.html'

export default {
  template,
  controller
}
